/**
 * Hook to get the current organization ID.
 *
 * Fetches the user's organizations and returns the first one.
 * Most users belong to a single organization.
 */

import { useQuery } from '@tanstack/react-query'
import { api } from '@/services/api'

export function useCurrentOrgId(): { orgId: string | undefined; isLoading: boolean } {
  const { data: organizations, isLoading } = useQuery({
    queryKey: ['organizations'],
    queryFn: () => api.listOrganizations(),
    staleTime: 5 * 60 * 1000,
  })

  return { orgId: organizations?.[0]?.id, isLoading }
}
